'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CurrentCardDetails = undefined;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CurrentCardDetails = exports.CurrentCardDetails = function CurrentCardDetails(_ref) {
  var lastFour = _ref.lastFour,
      name = _ref.name,
      expYear = _ref.expYear,
      expMonth = _ref.expMonth;
  return _react2.default.createElement(
    'div',
    null,
    name,
    _react2.default.createElement('br', null),
    '\u2022\u2022\u2022\u2022 \u2022\u2022\u2022\u2022 \u2022\u2022\u2022\u2022 ',
    lastFour,
    _react2.default.createElement('br', null),
    expMonth,
    '/',
    expYear
  );
};

CurrentCardDetails.propTypes = {
  name: _propTypes2.default.string.isRequired,
  lastFour: _propTypes2.default.string.isRequired,
  expMonth: _propTypes2.default.number.isRequired,
  expYear: _propTypes2.default.number.isRequired
};